export function isPastShift(shift) {
    const shiftStopTime = shift.startTime + shift.duration;
    return Date.now() > shiftStopTime;
}
export function showParticipantInPendingRequests(p) {
    const pendingStatuses = ['pending', 'deniedRosterFull', 'deniedNotQualified'];
    return pendingStatuses.some((s) => s === p.columns.status);
}
export function getParticipationStatus(userShiftParticipations) {
    if (!(userShiftParticipations === null || userShiftParticipations === void 0 ? void 0 : userShiftParticipations.length)) {
        return undefined;
    }
    const sortOrder = ['deleted', 'deniedNotQualified', 'deniedRosterFull', 'pending', 'approved'];
    userShiftParticipations.sort((p1, p2) => sortOrder.indexOf(p2.status) - sortOrder.indexOf(p1.status));
    return userShiftParticipations[0].status;
}
export function canApproveHours(selectedShiftParticipation) {
    return selectedShiftParticipation.columns.hoursStatus === 'pending';
}
export function canDenyHours(selectedShiftParticipation) {
    return ['pending', 'addHours', 'deniedInaccurate'].includes(selectedShiftParticipation.columns.hoursStatus);
}
